import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as S from './SignupComplete.styled';
import congratsIcon from 'assets/SignupImage/congrats.png';

function SignupComplete() {
  const navigate = useNavigate();

  const handleConfirm = () => {
    navigate('/login');
  };

  return (
    <S.Page>
      <S.Header>
        <S.Title>회원가입 완료</S.Title>
      </S.Header>

      <S.ContentWrap>
        <S.IconContainer>
          <S.CongratsIcon src={congratsIcon} alt="축하합니다" />
        </S.IconContainer>

        <S.MessageContainer>
          <S.MainMessage>회원가입이 완료되었습니다!</S.MainMessage>
          <S.SubMessage>
            지금 우리 학교는과 함께<br />
            쉽고 간편하게 시설을 예약해보세요.
          </S.SubMessage>
        </S.MessageContainer>
      </S.ContentWrap>

      <S.BottomButton onClick={handleConfirm}>
        확인
      </S.BottomButton>
    </S.Page>
  );
}

export default SignupComplete;
